import './App.css';

import { FocusStyleManager } from '@blueprintjs/core';
import AssistantFrame from 'ai-assistant/views/assistant-frame/AssistantFrame';
import { AssistantContextProvider } from 'ai-assistant/context/AssistantContext';
import { Provider } from 'react-redux';
import Routing from 'routes/Routing';

import configureStore from 'controllers/store';
import rootSaga from 'controllers/saga';

declare global {
  interface Window {
    REDUX_INITIAL_DATA: unknown;
  }
}

// disable focus borders when using a mouse
FocusStyleManager.onlyShowFocusOnTabs();

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);
reduxStore.runSaga(rootSaga);

function App(): JSX.Element {
  return (
    <div className="App">
      <Provider store={reduxStore}>
        <AssistantContextProvider>
          <Routing />
          <AssistantFrame />
        </AssistantContextProvider>
      </Provider>
    </div>
  );
}

export default App;



